<template lang="pug">
div
  .d-flex.align-center.justify-space-between
    .yz-heading-7.text-neutral-700 {{ supplier.value }}
    .d-flex(v-if="!disabled")
      yz-btn.mr-2(label="Edit" outlined size="sm" @click="onEdit")
      yz-btn(label="Delete" outlined size="sm" color="danger" @click="onDelete")
  yz-simple-table.mt-3
    template(v-slot:default)
      thead
        tr
          th.yz-medium-body-xs.text-neutral-500 PIC
          th.yz-medium-body-xs.text-neutral-500 Phone number
          th
      tbody
        tr(v-for="(contact, index) in contacts" :key="index")
          td.py-3
            .d-flex.align-center
              .yz-regular-body-sm.text-neutral-700 {{ contact.name }}
              yz-badge.ml-2(v-if="contact.default") Default
          td.py-3
            .yz-regular-body-sm.text-neutral-700 {{ contact.phone }}
          td.py-3.text-right
            template(v-if="!disabled")
              span.yz-heading-9.text-neutral-400(v-if="contact.default" style="text-decoration: underline;") Set as default
              span.yz-heading-9.text-neutral-700(v-else style="cursor: pointer; text-decoration: underline;" @click="onSetDefault(index)") Set as default
  add-new-supplier-dialog(:open.sync="showEditDialog" :edit-supplier="supplier" @updated="onSupplierUpdated")
  supplier-delete-confirmation-dialog(v-model="showDeleteDialog" :description="description" @confirmed="onConfirmDelete" @canceled="onCancelDelete")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddNewSupplierDialog from './AddNewSupplierDialog.vue'
import SupplierDeleteConfirmationDialog from './SupplierDeleteConfirmationDialog.vue'

export default {
  components: {
    AddNewSupplierDialog,
    SupplierDeleteConfirmationDialog
  },
  props: {
    supplier: {
      type: Object,
      required: true
    },
    companyId: {
      type: [Number, String],
      required: true
    },
    description: {
      type: String,
      default: "Removing this supplier will clear supplier details for all branches and warehouses. Branches may add their own supplier after deletion.\n\nClick 'Confirm' to proceed."
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showEditDialog: false,
      showDeleteDialog: false
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    contacts() {
      const data = this.supplier.extra_data
      if (!data) return []
      return Array.isArray(data) ? data : [data]
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onEdit() {
      this.showEditDialog = true
    },
    onDelete() {
      this.showDeleteDialog = true
    },
    onConfirmDelete() {
      this.showDeleteDialog = false
      this.$emit('deleted', this.supplier.id)
    },
    onCancelDelete() {
      this.showDeleteDialog = false
    },
    async onSetDefault(index) {
      try {
        const updatedExtraData = this.contacts.map((c, i) => ({
          ...c,
          default: i === index
        }))
        await this.$axios.patch(`/options/${this.supplier.id}`, { extra_data: updatedExtraData })
        this.showMessage(['success', 'Default contact updated'])
        this.$emit('updated')
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    },
    onSupplierUpdated(data) {
      this.$emit('updated', data)
    }
  }
}
</script>
